import Nullstack from 'nullstack';
export default function IconSnowman({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-snowman",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 3a4 4 0 0 1 2.906 6.75a6 6 0 1 1 -5.81 0a4 4 0 0 1 2.904 -6.75z"
  }), "   ", Nullstack.element("path", {
    d: "M17.5 11.5l2.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 11.5l-2.5 -1.5"
  }), "   ", Nullstack.element("path", {
    d: "M12 13h.01"
  }), "   ", Nullstack.element("path", {
    d: "M12 16h.01"
  }), " ");
}